export const environment = {
	production: true,
	API_BASE_URL: 'https://rails-api-dev.azurewebsites.net',
	apiUrl: 'https://rails-api-dev.azurewebsites.net/api',
	adminUrl: 'http://rails-admin-dev.azurewebsites.net',
	whiteListedEndpoints: ['rails-api-dev.azurewebsites.net'],
	activeDirectoryOptions: {
		clientId: '8a878cdd-dd45-4193-bce5-ee1d2001925f',
		redirectUri: window.location.origin,
		instance: 'https://login.microsoftonline.com/',
		tenant: '5384b56e-74f5-4534-b967-074c24d7d2f6' || 'railpros.com',
		postLogoutRedirectUri: 'http://rails-admin-dev.azurewebsites.net',
		cacheLocation: 'localStorage',
		scopes: [
			'https://railpros.com/be3a2360-ad91-40eb-811b-a5ce992fadf1/user_impersonation',
		],
	},
	appVersion: require('../../package.json').version,
	googleAnalyticsCode: 'UA-142492767-3',
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
import 'zone.js/plugins/zone-error'; // Included with Angular CLI.
